import React, { Component } from 'react'
import { connect } from 'react-redux'
import preload from 'components/enhancer/preload'
import { actions } from './redux'
import composeHOC from 'shared/utils/composeHOC'
import { Link } from 'react-router'
import moment from 'moment';
import Meta from 'components/layout/Meta';
import './News.scss'

class NewsDetail extends Component {
  constructor(props) {
    super(props)
    this.needLeftNavigation = false
  }
  state = {
    currentUrl: ''
  }
  componentDidMount(){

    const currentUrl = encodeURIComponent(location.href)
    this.setState({
      currentUrl
    })
    //职位申请页面
    $(".shareCon li").mouseover(function(){
      clearTimeout(this.timer);
      $(this).find(".popshare").show();
    });
    $(".shareCon li").mouseout(function(){
      var _this=this;
      this.timer=setTimeout(function(){
        $(_this).find(".popshare").hide();
      },100);
    });

  }

   menuChilderUrl=(catname,childCatname,id)=>{
    let locations=window.location && window.location.host.split('.')
    if((locations && !/^(ztx-uat|ztx-sit|127|localhost)$/.test(locations[0])) || !locations){
      let page=(childCatname=='news' || childCatname=='loaninfo')?'/show-'+id+'.html':''
      let childerUrl=''
      // if(/^(announcement|shareholder|qurCulture)$/.test(childCatname)){
        childerUrl=catname+ '/' +(id?(childCatname=='news'?'news':'loaninfodetail' ):childCatname)
      // }
      return 'https://'+this.prefixUrlChilder(childCatname)+".chinatopcredit.com/"+childerUrl+page
    }else{
     return '/' + catname + '/' + childCatname+(/^(news|loaninfodetail)$/.test(childCatname)?'/show-'+id+'.html':'')
    }
  }


   prefixUrlChilder=(catname)=>{
    switch (catname){
      default :
      return 'www'
    }
  }


  render() {
    const {news, newsList} = this.props
    const currentUrl = this.state.currentUrl

    return(
      <div className="newsDetail content-width newsDetailCon">
        <Meta location={this.props.location} title={news.currentData.title + '-新闻动态-关于我们'}/>
        <div className="newsCon">
          <div className="newsTitle">
            <h1 className="newsTitle-text">{news && news.currentData.title}</h1>
            <div className="flex-row">
              <div>
                <span className="pr-30">
                  {news && moment(news.currentData.publish_time || news.currentData.created_at*1000).format('YYYY-MM-DD hh:mm:ss')}
                </span>
                来源：{news && news.currentData.source}
              </div>

              <div className="shareCon">
                分享到
                <div className="share_a">
                  <a target="_blank" rel="nofollow"  href="http://service.weibo.com/share/share.php?title=中腾信官网&amp;url=http://www.chinatopcredit.com/news/detail.htm%3Fid%3Dff80808159b5b333015b130872dd00f7&amp;appkey=2992571369&amp;pic=/staticimages/fenxiang.jpg" title="新浪微博" className="sinashare">新浪微博</a>
                  <a target="_blank" href={`/qrCode?currentUrl=${currentUrl}`} title="微信分享" rel="nofollow" className="wxshare">微信分享</a>
                  <a target="_blank" rel="nofollow" href="http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=http://www.chinatopcredit.com/news/detail.htm%3Fid%3Dff80808159b5b333015b130872dd00f7&amp;title=中腾信官网&amp;pics=/staticimages/fenxiang.jpg" title="QQ空间" className="QQshare">QQ空间</a>
                </div>
              </div>

            </div>
          </div>
          <div dangerouslySetInnerHTML={{__html: news && news.currentData.content}}></div>

          <div className="page_num flex-row">
            <div>
              <p>上一篇 {news.previousData && <a href={this.menuChilderUrl('aboutUs','news',news.previousData.id)} title={news.previousData.title}>{news.previousData.title}</a>}</p>
              <p>下一篇 {news.nextData && <a href={this.menuChilderUrl('aboutUs','news',news.nextData.id)} title={news.nextData.title}>{news.nextData.title}</a>}</p>
            </div>
            <div className="shareCon">
              分享到
              <div className="share_a">
                <a target="_blank" rel="nofollow"  href="http://service.weibo.com/share/share.php?title=中腾信官网&amp;url=http://www.chinatopcredit.com/news/detail.htm%3Fid%3Dff80808159b5b333015b130872dd00f7&amp;appkey=2992571369&amp;pic=/staticimages/fenxiang.jpg" title="新浪微博" className="sinashare">新浪微博</a>
                <a target="_blank" href={`/qrCode?currentUrl=${currentUrl}`} title="微信分享" rel="nofollow" className="wxshare">微信分享</a>
                <a target="_blank" rel="nofollow" href="http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=http://www.chinatopcredit.com/news/detail.htm%3Fid%3Dff80808159b5b333015b130872dd00f7&amp;title=中腾信官网&amp;pics=/staticimages/fenxiang.jpg" title="QQ空间" className="QQshare">QQ空间</a>
              </div>
            </div>
          </div>
        </div>
        <div className="list_right">

          <div className="news_wx">
            <img src={require('./images/news_wx.png')}/>
            <p>关注中腾信服务官方微信</p>
          </div>

          <dl>
            <dt>热门动态</dt>
            {newsList && newsList.map((item, i) => {
              return i <= 4 ? (
                <dd key={i}>
                  <a href={this.newsDetailUrl('/aboutUs/news/', item.id)}>· {item.title}</a>
                </dd>
              ): null
            })}
          </dl>

        </div>
      </div>
    )
  }
  newsDetailUrl(linkPrefix,id){
    let urls=linkPrefix.split('/')
    let locations=window.location && window.location.host.split('.')
    let urlId=/^(news|loaninfodetail)*$/.test(urls[2])?('show-'+id+'.html'):id
    if((locations && !/^(ztx2|ztx1|127|localhost)$/.test(locations[0])) || !locations){//ztx2|ztx1|127分别uat,sit,本地
      let childerUrl=''
      childerUrl=urls[2]=='news'?'aboutUs/news/':'aboutUs/loaninfodetail/'
      //  return 'http://'+urls[2]+'.chinatopcredit.com/'+childerUrl+'show-'+id+'.html'
      return 'https://www.chinatopcredit.com/'+childerUrl+urlId

    }else{
      return linkPrefix+urlId


    }
  }
}


export default composeHOC(
  connect(state => ({
    news: state.aboutUs.news,
    newsList: state.aboutUs.newsList,
  }), {
  }),
  preload(({dispatch, location}) => {
    //const newsId = location.pathname.substr( location.pathname.lastIndexOf('/') + 1 )
    //const newsId = location.pathname.substr( location.pathname.lastIndexOf('/') + 1 ).split('.')[0].split('-')[1]

    const locationSplit = location.pathname.substr( location.pathname.lastIndexOf('/') + 1 ).split('.')
    let newsId
    if(locationSplit.length>1){
      newsId = locationSplit[0].split('-')[1]
    }else{
      newsId = locationSplit[0]
    }
    return Promise.all([
      dispatch(actions.getNewsDetail(newsId)),
      dispatch(actions.getNewsList(1))
    ])
  })
)(NewsDetail)



// WEBPACK FOOTER //
// ./modules/aboutUs/NewsDetail.js